import { render } from "./dan-alix-polish-sec.vue?vue&type=template&id=d912a960&scoped=true"
import script from "./dan-alix-polish-sec.vue?vue&type=script&lang=js"
export * from "./dan-alix-polish-sec.vue?vue&type=script&lang=js"

import "./dan-alix-polish-sec.vue?vue&type=style&index=0&id=d912a960&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d912a960"]])

export default __exports__